<template>
  <div>
    <div class="up-input-group">
      <up-select v-model="ruler.type" label="Type" labelIcon="mdi mdi-alpha-t-box-outline">
        <option value="C">Centimeter</option>
        <option value="I">Inch</option>
      </up-select>
      <up-select v-model="ruler.design" label="Design" labelIcon="mdi mdi-alpha-d-box-outline">
        <option value="H">Horizontal</option>
        <option value="V">Vertical</option>
      </up-select>
      <up-numberinput
        v-model="ruler.start"
        label="Start"
        labelIcon="mdi mdi-alpha-s-box-outline"
      ></up-numberinput>
      <up-numberinput
        v-model="ruler.end"
        label="End"
        labelIcon="mdi mdi-alpha-e-box-outline"
      ></up-numberinput>
      <up-numberinput
        v-model="ruler.stepsize"
        label="Stepsize"
        labelIcon="mdi mdi-alpha-s-box-outline"
      ></up-numberinput>
      <up-numberinput
        v-model="ruler.num_lines"
        label="No. Lines"
        labelIcon="mdi mdi-alpha-l-box-outline"
      ></up-numberinput>
    </div>
    <style-editor
      v-model="ruler.styles"
      show_height
      show_width
      show_bg_color
      show_font_color
      show_border_color
    ></style-editor>
    <show-ruler :ruler="ruler"></show-ruler>
  </div>
</template>

<script>
import ShowRuler from "./ShowRuler.vue";
import { defaultRulerValue } from "./utils/";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSelect from "@/components/UI/Inputs/UpSelect";

export default {
  name: "set-ruler",
  components: {
    ShowRuler,
    StyleEditor,
    UpNumberinput,
    UpSelect,
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      ruler: this.value ? this.value : defaultRulerValue(),
    };
  },
  watch: {
    value: {
      handler: function(new_value) {
        this.ruler = new_value;
      },
      deep: true,
    },
    ruler: {
      handler: function(new_value) {
        this.$emit("input", new_value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
